import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOSchema from '@/components/base/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PopularContent from './components/PopularContent';
import CreatorShowcase from './components/CreatorShowcase';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import DownloadCTA from './components/DownloadCTA';
import { faqs } from '@/mocks/home';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema
        type="WebSite"
        data={{
          name: '香蕉视频',
          url: 'https://whtefafuwu.cn',
          description: '香蕉视频是一款深受年轻用户喜爱的创意短视频平台，提供海量原创内容、趣味挑战与互动社区。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://whtefafuwu.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SEOSchema
        type="Organization"
        data={{
          name: '香蕉视频',
          url: 'https://whtefafuwu.cn',
          description: '创意短视频平台',
          foundingDate: '2020',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+86-400-888-9999',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
        }}
      />
      <SEOSchema
        type="WebPage"
        data={{
          name: '香蕉视频 - 创意短视频平台官方入口',
          description: '发现精彩创作，记录生活每一刻',
          url: 'https://whtefafuwu.cn',
          isPartOf: { '@type': 'WebSite', name: '香蕉视频', url: 'https://whtefafuwu.cn' },
        }}
      />
      <SEOSchema
        type="FAQPage"
        data={{
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <PopularContent />
        <CreatorShowcase />
        <FAQSection />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}